export default class MailchimpSignup {
  constructor(element) {
    this.el = element
    this.init()
  }

  init() {
    const client = require("@mailchimp/mailchimp_marketing");

    client.setConfig({
      apiKey: "7eb9fc9d34068e154f62525b22275ba2-us7",
      server: "us7",
    });

    const run = async () => {
      const response = await client.lists.getAllLists();
      console.log(response);
    };

    run();
  }
}
